import React from "react";
interface AboutProps {
  //
}

const About: React.FC<AboutProps> = () => (
  <section className="bg-primary text-white mb-0" id="about">
    <div className="container">
      <h2 className="text-center text-uppercase text-white">About Me</h2>
      <hr className="star-light mb-5" />
      <div className="row">
        <div className="col-lg-4 ml-auto">
          <p className="lead">
            Computer Science graduate from Technical Univeristy of Kenya.
            Greatly passionate about business development, communication and
            leadership. I am also passionate about making sure that softwares
            are human-friendly, emotive, aesthetically pleasing and clear.
          </p>
        </div>
        <div className="col-lg-4 mr-auto">
          <p className="lead">
            I have worked in variety of environments, from mega-consultancies to
            small-ish agencies to product companies. From workflow diagrams to
            detailed user interface mockups, I love shaping and crafting
            on-screen experiences.{" "}
          </p>
        </div>
      </div>
      <div className="text-center mt-4">
        <a
          className="btn btn-xl btn-outline-light"
          href="mailto:hillkim@pm.me"
          download
        >
          <i className="fas fa-email mr-2"></i>
          Hire Me!
        </a>
      </div>
    </div>
  </section>
);

export default About;
